<template>
  <div class="form__bloc">
    <div class="gridWrapper">
      <div class="cardLayoutWrapper cardLayoutWrapper--header">
        <div class="elem elem--span-7">
          <span>Stagiaire</span>
        </div>
        <div class="elem elem--span-13"></div>
        <div class="elem elem--span-5">
          <span>Date de début</span>
        </div>
        <div class="elem elem--span-5">
          <span>Date de fin</span>
        </div>
        <div class="elem elem--span-5">
          <span>Présence déclarée (durée)</span>
        </div>
      </div>
      <div
        v-for="item in attestations"
        :key="item.idSalarie!"
        class="gridElemWrapper"
      >
        <div class="cardLayoutWrapper">
          <div class="elem elem--span-7">
            <span>{{ item.prenom }} {{ item.nom }}</span>
          </div>
          <div class="elem elem--span-13"></div>
          <div class="elem elem--span-5">
            <WrapperInputDate
              v-if="meta?.attestations?.at(item.index)?.dateDebut?.$status !== PropertyStatus.NotPresent"
              :model-value="item.dateDebut"
              @update:model-value="(value) => updateAttestations('dateDebut', item.index, value)"
              :required="meta.attestations?.at(item.index)?.dateDebut?.$status === PropertyStatus.Required"
              :alert-label="meta?.attestations?.at(item.index)?.dateDebut?.$messageErreurDirty!"
              input-type="table"
              :readonly
              deletable
            />
            <WrapperInputDate
              v-else
              disabled
              input-type="table"
            />
          </div>
          <div class="elem elem--span-5">
            <WrapperInputDate
              v-if="meta?.attestations?.at(item.index)?.dateFin?.$status !== PropertyStatus.NotPresent"
              :model-value="item.dateFin"
              @update:model-value="(value) => updateAttestations('dateFin', item.index, value)"
              :required="meta.attestations?.at(item.index)?.dateFin?.$status === PropertyStatus.Required"
              :alert-label="meta?.attestations?.at(item.index)?.dateFin?.$messageErreurDirty!"
              input-type="table"
              :readonly
              deletable
            />
            <WrapperInputDate
              v-else
              input-type="table"
              disabled
            />
          </div>
          <div class="elem elem--span-5">
            <WrapperInputDuree
              v-if="meta?.attestations?.at(item.index)?.duree?.$status !== PropertyStatus.NotPresent"
              :model-value="floatToInputDuree(item.duree)"
              @update:model-value="(value) => updateAttestations('duree', item.index, inputDureeToFloat(value))"
              :required="meta.attestations?.at(item.index)?.duree?.$status === PropertyStatus.Required"
              :disabled="meta?.attestations?.at(item.index)?.duree?.$status === PropertyStatus.NotPresent"
              :alert-label="meta?.attestations?.at(item.index)?.duree?.$messageErreurDirty!"
              input-type="table"
              :placeholder="PLACEHOLDER_DUREE"
              :readonly
              deletable
            />
            <WrapperInputDuree
              v-else
              input-type="table"
              :placeholder="PLACEHOLDER_DUREE"
              disabled
            />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="block-mobile">
    <div
      v-for="item in attestations"
      :key="item.idSalarie!"
      class="card"
    >
      <div class="card__top">
        <div class="card__top__text">
          <BasicText weight="bold">{{ item.nom }} {{ item.prenom }}</BasicText>
        </div>
      </div>
      <div class="card__section">
        <div class="elem">
          <span>Date de début</span>
          <WrapperInputDate
            v-if="meta?.attestations?.at(item.index)?.dateDebut?.$status !== PropertyStatus.NotPresent"
            :model-value="item.dateDebut"
            @update:model-value="(value) => updateAttestations('dateDebut', item.index, value)"
            :required="meta.attestations?.at(item.index)?.dateDebut?.$status === PropertyStatus.Required"
            :alert-label="meta?.attestations?.at(item.index)?.dateDebut?.$messageErreurDirty!"
            :readonly
            deletable
          />
          <WrapperInputDate
            v-else
            disabled
          />
        </div>
        <div class="elem">
          <span>Date de fin</span>
          <WrapperInputDate
            v-if="meta?.attestations?.at(item.index)?.dateFin?.$status !== PropertyStatus.NotPresent"
            :model-value="item.dateFin"
            @update:model-value="(value) => updateAttestations('dateFin', item.index, value)"
            :required="meta.attestations?.at(item.index)?.dateFin?.$status === PropertyStatus.Required"
            :alert-label="meta?.attestations?.at(item.index)?.dateFin?.$messageErreurDirty!"
            :readonly
            deletable
          />
          <WrapperInputDate
            v-else
            disabled
          />
        </div>
        <div class="elem">
          <span>Présence déclarée (durée)</span>
          <WrapperInputDuree
            v-if="meta?.attestations?.at(item.index)?.duree?.$status !== PropertyStatus.NotPresent"
            :model-value="floatToInputDuree(item.duree)"
            @update:model-value="(value) => updateAttestations('duree', item.index, inputDureeToFloat(value))"
            :required="meta.attestations?.at(item.index)?.duree?.$status === PropertyStatus.Required"
            :alert-label="meta?.attestations?.at(item.index)?.duree?.$messageErreurDirty!"
            :placeholder="PLACEHOLDER_DUREE"
            :readonly
            deletable
          />
          <WrapperInputDuree
            v-else
            :placeholder="PLACEHOLDER_DUREE"
            disabled
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { useModuleAttestations } from '../../useModuleAttestations'
  import { PropertyStatus } from '@/features/domaine/property-status'
  import { floatToInputDuree, inputDureeToFloat } from '@/features/interface/shared/tools'
  import { PLACEHOLDER_DUREE } from '@/features/interface/demande/shared'

  const props = defineProps<{
    moduleIndex: number
  }>()
  const state = useModuleAttestations(props.moduleIndex)

  const { attestations, meta, updateAttestations, readonly } = state

</script>

<style lang="less" scoped>
  @import '../StagiaireSection.less';
</style>
